<template>
  <div class="main_content">
    <a-layout-header>
      <div class="header_zj">
        <img class="logo"
             src="@/assets/logo.png">
        <div class="header_title">专家入库申请表</div>
        <div class="consult_tel">咨询电话：{{ consult_telePhone }}</div>
      </div>
    </a-layout-header>
    <a-layout-content v-if="!submitSuccess">
      <a-card class="mb-5">
        <a-form-model ref="form"
                      :model="form"
                      :rules="rules"
                      :label-col="{ flex: '0 0 auto' }"
                      :wrapper-col="{ span: 24 }"
                      class="exi_form item_100 large">
          <div class="title">基本信息</div>
          <a-divider/>
          <a-row :gutter="20">
            <a-col :span="16">
              <a-row :gutter="20"
                     type="flex">
                <a-col :span="12">
                  <a-form-model-item label="证件类型"
                                     prop="certificateType">
                    <dict-radio v-model="form.certificateType"
                                dictKey="certificate_type"
                                placeholder="证件类型"
                                @change="onCertificateTypeChange"/>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item prop="idCard"
                                     has-feedback
                                     :rules="{validator: checkIdCard,trigger: 'blur'}">
                    <span slot="label"><span class="font-red">*</span>证件号码</span>
                    <a-input v-model.trim="form.idCard"
                             placeholder="证件号码"/>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="姓名"
                                     prop="expertName">
                    <a-input v-model.trim="form.expertName"
                             placeholder="姓名"/>
                  </a-form-model-item>
                </a-col>
                <!-- <a-col :span="8">
            <a-form-model-item label="出生年月"
                               prop="birthdate">
              <a-date-picker v-model="form.birthdate"
                             format="YYYY-MM-DD"
                             placeholder="出生年月"
                             style="width: 100%" />
            </a-form-model-item>
          </a-col> -->
                <a-col :span="12">
                  <a-form-model-item label="性别"
                                     prop="gender">
                    <dict-radio v-model="form.gender"
                                dictKey="PEOPLE.SEX"
                                placeholder="性别"
                                @change="(val) => { form.gender = val }"/>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item prop="mobilePhone"
                                     has-feedback>
                    <span slot="label"><span class="font-red">*</span>手机号码</span>
                    <a-input v-model.trim="form.mobilePhone"
                             placeholder="手机号码"/>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="所在行政区域"
                                     prop="areaAddress">
                    <dict-cascader v-model="form.areaAddress"
                                   dictKey="COUNTRY.CITY" :changeOnSelect="false"
                                   placeholder="所在行政区域"
                                   style="width: 100%"/>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24">
                  <a-form-model-item label="联系地址"
                                     prop="address">
                    <a-input v-model.trim="form.address"
                             placeholder="联系地址"/>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="紧急联系电话"
                                     prop="emergencyMobilePhone">
                    <a-input v-model.trim="form.emergencyMobilePhone"
                             placeholder="紧急联系电话"/>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="电子邮箱"
                                     prop="email">
                    <a-input v-model.trim="form.email"
                             placeholder="电子邮箱"/>
                  </a-form-model-item>
                </a-col>

              </a-row>
            </a-col>
            <a-col :span="8">
              <a-form-model-item prop="peoplePicture"
                                 has-feedback>
                <span slot="label"><span class="font-red">*</span>照片</span>
              </a-form-model-item>
              <a-upload list-type="picture-card"
                        :file-list="peoplePictureList"
                        accept=".jpg,.jpeg,.png"
                        :remove="handlePeoplePictureRemove"
                        :before-upload="beforePeoplePictureUpload"
                        @preview="handlePreview">
                <div v-if="peoplePictureList.length < 1">
                  <a-icon type="plus"/>
                  <div class="ant-upload-text">
                    上传照片
                  </div>
                </div>
              </a-upload>
              <div class="descrition-text">请上传1寸或2寸本人免冠正面头像照片（证件照为佳）</div>
              <div class="descrition-text">请上传不超过2M大小的照片，并且仅支持PNG、JPG、JPEG格式</div>
            </a-col>
          </a-row>

          <div class="title">工作信息</div>
          <a-divider/>
          <a-row :gutter="20">
            <a-col :span="8">
              <a-form-model-item label="是否在职"
                                 prop="isIncumbency">
                <dict-radio v-model="form.isIncumbency"
                            dictKey="is_incumbency"
                            placeholder="是否在职"
                            @change="(val) => { if(val==='1'){ form.retireDate= null }else { form.unitProperties ='';form.position=''}}"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="16">
              <a-form-model-item :label="form.isIncumbency==='0'?'退休工作单位全称':'当前工作单位全称'"
                                 prop="unitName"
                                 :rules="[{ required: true, message:'请输入工作单位全称',trigger: 'blur' },
                               {max: 50,message: '单位全称有误！最多50个字',trigger: 'blur'}]">
                <a-input v-model.trim="form.unitName"
                         placeholder="请输入"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="20">
            <a-col :span="8" v-if="form.isIncumbency==='0'">
              <a-form-model-item label="退休日期"
                                 prop="retireDate"
                                 :rules="[{ required: true, message: '请选择退休日期', trigger: 'change' }]">
                <a-month-picker v-model="form.retireDate" :disabled-date="disabledDate"
                                format="YYYY年MM月"
                                placeholder="退休日期"
                                style="width: 100%"/>
              </a-form-model-item>
            </a-col>
            <template v-if="form.isIncumbency==='1'">
              <a-col :span="8">
                <a-form-model-item label="当前工作单位性质"
                                   prop="unitProperties">
                  <dict-cascader v-model="form.unitProperties"
                                 :showSearch="false"
                                 dictKey="expert_unitProperties"
                                 placeholder="当前工作单位性质"
                                 style="width: 100%"/>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="职务"
                                   prop="position">
                  <a-input v-model="form.position"
                           placeholder="职务"/>
                </a-form-model-item>
              </a-col>
            </template>

          </a-row>
          <a-row :gutter="20">
            <a-col>
              <a-form-model-item label="其他需回避的单位"
                                 prop="avoidUnit">
                <a-textarea v-model="form.avoidUnit"
                            auto-size
                            placeholder="请输入单位的标准全称，并且每个单位单独占一行。如没有回避单位则留空不填。"></a-textarea>
              </a-form-model-item>
              <div class="descrition-instructions">
                <div>其他需回避单位包括：</div>
                <div>（1）三年内担任过董事、监事、控股股东或实际控制人的单位；</div>
                <div>（2）夫妻、直系血亲、三代以内旁系血亲或者近姻亲关系的担任法定代表人或者负责人的单位；</div>
                <div>（3）因其他原因可能影响采购活动公平、公正进行的关系单位。</div>
              </div>
            </a-col>
          </a-row>
          <div class="title">专业领域信息</div>
          <a-divider/>
          <a-row :gutter="20">
            <a-col>
              <a-form-model-item label="是否为国家库、省库专家"
                                 prop="otherSourceLibrary"
                                 has-feedback
                                 :rules="{ required: true,validator: checkSourceLibrary,trigger: 'blur'}">
                <a-radio-group name="radioGroup"
                               v-model="form.otherSourceLibraryFlag"
                               @change="changeOtherSourceLibraryFlag">
                  <a-radio :value="false">否</a-radio>
                  <a-radio :value="true">是</a-radio>
                </a-radio-group>
                <dict-checkbox class="ml-5"
                               v-show="form.otherSourceLibraryFlag"
                               :value="otherSourceLibrary"
                               dictKey="other_expertbank"
                               placeholder="是否为国家库、省库、省综合库专家"
                               @change="onOtherSourceLibraryChange"/>
              </a-form-model-item>
            </a-col>
            <a-col>
              <a-form-model-item label="选择评审品目"
                                 prop="purchaseItem">
                <div class="d-flex">
                  <a-input :placeholder="`最多可选择${expert_item_max_num}个品目`"
                           readOnly
                           v-model="form.purchaseItem"
                           @click="openPurchaseItems"></a-input>
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="20">
            <a-col :span="8">
              <a-form-model-item label="毕业院校"
                                 prop="school">
                <a-input v-model="form.school"
                         placeholder="毕业院校"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="最高学历"
                                 prop="education">
                <dict-cascader v-model="form.education"
                               :showSearch="false"
                               dictKey="expert_education"
                               placeholder="最高学历"
                               style="width: 100%"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="职称水平"
                                 prop="professionalTitle">
                <dict-cascader v-model="form.professionalTitle"
                               :showSearch="false"
                               dictKey="expert_professionalTitle"
                               placeholder="职称水平"
                               style="width: 100%"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="20" v-if="form.professionalTitle">
            <a-col>
              <a-form-model-item label="职称名称"
                                 prop="specificProfessionalTitle">
                <div class="d-flex">
                  <a-input v-model="form.specificProfessionalTitle"
                           placeholder="职称名称"
                           readOnly
                           @click="openProfessional"></a-input>
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="20">
            <a-col>
              <a-form-model-item label="专业领域"
                                 prop="skilledProfession">
                <a-textarea v-model="form.skilledProfession"
                            auto-size
                            placeholder="请对擅长的领域进行简要描述，可增加被抽中参加方案评审、需求调研、项目论证等非评标活动的几率。，字数在500字以内"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="20">
            <a-col>
              <a-form-model-item label="学术成果"
                                 prop="majorResult">
                <a-textarea v-model="form.majorResult"
                            auto-size
                            placeholder="请输入学术成果，字数在500字以内"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="20">
            <a-col>
              <a-form-model-item label="获得奖励"
                                 prop="reward">
                <a-textarea v-model="form.reward"
                            placeholder="请输入获得奖励，字数在500字以内"
                            auto-size/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <div class="title">证明材料</div>
          <a-divider/>
          <a-row :gutter="20">
            <a-col :span="12">
              <a-form-model-item class="horizontal"
                                 prop="iDCardScanned"
                                 has-feedback>
                <div class="inline-flex"
                     slot="label">
                  <span class="font-red">*</span>身份证扫描件
                  <small>（文件格式为PDF、PNG、JPG、JPEG，单个大小不超过2M）</small>
                </div>

                <upload-file ref="iDCardScanned"
                             :fileSize="2"
                             btnSize="large"
                             accept=".pdf,.jpg,.jpeg,.png"
                             @change="iDCardScannedUploadFileChange"/>
              </a-form-model-item>

            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="diploma"
                                 class="horizontal"
                                 has-feedback>
                <div class="inline-flex"
                     slot="label">
                  <span class="font-red">*</span>学历证书/毕业证书
                  <small>（文件格式为PDF、PNG、JPG、JPEG，单个大小不超过2M）</small>
                </div>
                <upload-file ref="diploma"
                             :fileSize="2"
                             btnSize="large"
                             accept=".pdf,.jpg,.jpeg,.png"
                             @change="diplomaUploadFileChange"/>
              </a-form-model-item>
            </a-col>

          </a-row>
          <a-row :gutter="20">
            <a-col :span="12">
              <a-form-model-item prop="technicalTitleCertificates"
                                 class="horizontal"
                                 has-feedback>
                <div class="inline-flex"
                     slot="label">
                  <span class="font-red">*</span>专业技术职称证书
                  <small>（文件格式为PDF、PNG、JPG、JPEG，单个大小不超过2M）</small>
                </div>
                <upload-file ref="technicalTitleCertificatesUploadFile"
                             :fileSize="2"
                             btnSize="large"
                             accept=".pdf,.jpg,.jpeg,.png"
                             @change="technicalTitleCertificatesUploaFileChange"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12"
                   v-if="form.otherSourceLibraryFlag">
              <a-form-model-item class="horizontal"
                                 prop="otherSourceLibraryFile"
                                 has-feedback
                                 :rules="{required: true,validator: otherSourceLibraryValidator,trigger: 'blur'}">
                <div class="inline-flex"
                     slot="label">
                  国家、省库专家证明材料
                  <small>（文件格式为PDF、PNG、JPG、JPEG，单个大小不超过2M）</small>
                </div>
                <upload-file ref="otherSourceLibraryUploadFile"
                             :fileSize="2"
                             btnSize="large"
                             accept=".pdf,.jpg,.jpeg,.png"
                             @change="otherSourceLibraryUploadFileChange"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="form.otherSourceLibraryFlag?24:12">
              <a-form-model-item class="horizontal"
                                 prop="jobQualificationCertificate"
                                 has-feedback>
                <div class="inline-flex"
                     slot="label">
                  职业资格证书等其他资料
                  <small>（文件格式为PDF、PNG、JPG、JPEG，单个大小不超过2M）</small>
                </div>
                <upload-file ref="jobQualificationCertificateUploadFile"
                             :fileSize="2"
                             btnSize="large"
                             accept=".pdf,.jpg,.jpeg,.png"
                             @change="jobQualificationCertificateUploadFileChange"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
        <choose-expert-purchase-item ref="items"
                                     :visible="purchaseVisible"
                                     @success="purchaseSuccess"
                                     @cancel="purchaseVisible=false"/>
        <choose-expert-professional-title ref="professionalRef"
                                          :visible="professionalVisible"
                                          @success="professionalSuccess"
                                          @cancel="professionalVisible=false"/>
        <div style="width: 200px;margin: auto">
          <a-button type="primary"
                    class="mt-5"
                    block
                    size="large"
                    :loading="saveLoading"
                    @click="submit">提交
          </a-button>
        </div>

      </a-card>
      <MobilePhoneCheckModal ref="mobilePhoneCheckModal"
                             @sumitSuccess="onHandleSubmit"/>
    </a-layout-content>
    <a-result status="success"
              title="提交成功，审核结果将通过手机短信通知您。"
              v-else>
      <template #extra>
      </template>
    </a-result>
    <ExpertApplyForTipsModal></ExpertApplyForTipsModal>
  </div>
</template>

<script>
import { PageView } from '@/layouts'
import ProcessSelector from '@/components/workflow/ProcessSelector'
import FooterToolBar from '@/components/FooterToolbar'
import DictRadio from '@/components/dict/DictRadio'
import DictCheckbox from '@/components/dict/DictCheckbox'
import DictCascader from '@/components/dict/DictCascader'
import { verify } from '@/epp/expertmain/common/js/verify.js'
import {
  CheckIdCard,
  CheckMobilePhone,
  SaveOutExpert
} from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import { formWaring } from '@/epp/expertmain/selectexpertapply/utils/ExpertApplyUtils'
import UploadFile from '@/components/selector/UploadFile'
import MobilePhoneCheckModal from './MobilePhoneCheckModal'
import { GetPurchaseItemLimitNumAndConsultTelePhone } from '@/epp/sysContentMange/api/sysContentMangeApi'
import ChooseExpertPurchaseItem from '@/epp/expertmain/purchaseitems/ChooseExpertPurchaseItem.vue'
import ExpertApplyForTipsModal from './ExpertApplyForTipsModal.vue'
import moment from 'moment'
import { CalculateAge } from '@/epp/expertmain/expertInfo/utils/ExpertFormUtil'
import ChooseExpertProfessionalTitle from '@/epp/expertmain/purchaseitems/ChooseExpertProfessionalTitle.vue'

const uuidv4 = require('uuid/v4')

function getBase64 (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

export default {
  name: 'ExpertApplyFor',
  components: {
    ChooseExpertProfessionalTitle,
    ChooseExpertPurchaseItem,
    PageView,
    DictRadio,
    DictCascader,
    FooterToolBar,
    ProcessSelector,
    UploadFile,
    MobilePhoneCheckModal,
    DictCheckbox,
    ExpertApplyForTipsModal
  },
  data () {
    let checkMobilePhone = async (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号码'))
      }
      /* 手机号码不做正则表达式校验
      if (!new RegExp(verify.pattern_mobilePhone).test(value)) {
        return callback(new Error('手机号码不正确'))
      } */
      const consult_telePhone = this.consult_telePhone
      const res = await CheckMobilePhone(value)
      if (res.code !== 200) {
        return callback(new Error(res.msg + (res.code == 423 ? `,请拨打${consult_telePhone}电话咨询。` : res.code == 424 ? `,请尝试登录或联系${consult_telePhone}咨询` : '')))
      }
    }
    let checkIDCardScanned = async (rule, value, callback) => {
      if (this.iDCardScannedFileList.length == 0) {
        return callback(new Error('请上传身份证扫描件'))
      }
      callback()
    }
    let checkDiploma = (rule, value, callback) => {
      if (this.diplomaFileList.length == 0) {
        return callback(new Error('请上传学历证书/毕业证书'))
      }
      callback()
    }
    let checkTechnicalTitleCertificates = (rule, value, callback) => {
      if (this.technicalTitleCertificatesFileList.length == 0) {
        return callback(new Error('请上传专业技术职称证书'))
      }
      callback()
    }
    let checkPeoplePicture = (rule, value, callback) => {
      if (this.peoplePictureList.length == 0) {
        return callback(new Error('请上传个人照片'))
      }
      callback()
    }
    const checkPurchaseItemNum = (rule, value, callback) => {
      if (this.form.purchaseItem && this.form.purchaseItem.split(',').length > this.expert_item_max_num) {
        callback(new Error(`评审品目有误！最多选择${this.expert_item_max_num}个评审品目`))
      }
      callback()
    }
    return {
      // 咨询电话
      consult_telePhone: '',
      // 专家品目最多选择个数
      expert_item_max_num: 1,
      submitSuccess: false,
      verify,
      form: {
        id: uuidv4(),
        purchaseItem: undefined,
        purchaseItemCode: undefined,
        purchaseItemId: undefined,
        areaAddress: undefined,
        emergencyMobilePhone: '',
        isIncumbency: '1',
        otherSourceLibrary: '',
        otherSourceLibraryFlag: false,
        retireDate: null,
        specificProfessionalTitle: '',
        specificProfessionalTitleKey: '',
        otherSpecificProfessionalTitle: '',
        position: '',
      },
      otherSourceLibrary: [],
      saveLoading: false,
      purchaseVisible: false,
      professionalVisible: false,
      peoplePictureList: [],
      diplomaFileList: [],
      technicalTitleCertificatesFileList: [],
      jobQualificationCertificateFileList: [],
      otherSourceLibraryFileList: [],
      iDCardScannedFileList: [],
      retireYear: 0,
      rules: {
        certificateType: [{ required: true, message: '请选择证件类型', trigger: 'blur' }],
        expertName: [{ required: true, message: '请输入专家名称', trigger: 'blur' }],
        peoplePicture: [{ validator: checkPeoplePicture, trigger: 'blur' }],
        purchaseItem: [{
          required: true,
          message: '请选择评审品目',
          trigger: 'blur'
        }, { validator: checkPurchaseItemNum, trigger: 'change' }],
        mobilePhone: [{ validator: checkMobilePhone, trigger: 'blur' }],
        email: [{ pattern: verify.pattern_email, message: '电子邮箱有误！', trigger: 'blur' }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        isIncumbency: [{ required: true, message: '请选择是否在职', trigger: 'change' }],
        position: [{ max: 50, message: '职务有误！最多50个字', trigger: 'change' }],
        school: [{ required: true, message: '毕业院校不能为空', trigger: 'blur' },
          { max: 100, message: '毕业院校有误！最多100个字', trigger: 'change' }],
        education: [{ required: true, message: '请选择最高学历', trigger: 'change' }],
        professionalTitle: [{ required: true, message: '请选择当前职称', trigger: 'change' }],
        specificProfessionalTitle: [{ required: true, message: '请选择具体职称名称', trigger: 'change' }],
        skilledProfession: [{ max: 500, message: '专业领域有误！最多500个字', trigger: 'change' }],
        majorResult: [{ max: 500, message: '学术成果有误！最多500个字', trigger: 'change' }],
        reward: [{ max: 500, message: '获得奖励有误！最多500个字', trigger: 'change' }],
        unitProperties: [{ required: true, message: '请选择当前工作单位性质', trigger: 'change' }],
        areaAddress: [{ required: true, message: '请选择行政区域', trigger: 'change' }],
        address: [{ required: true, message: '请输入联系地址', trigger: 'blur' },
          { max: 150, message: '联系地址有误！最多150个字', trigger: 'change' }],
        iDCardScanned: [{ validator: checkIDCardScanned, trigger: 'blur' }],
        diploma: [{ validator: checkDiploma, trigger: 'blur' }],
        technicalTitleCertificates: [{ validator: checkTechnicalTitleCertificates, trigger: 'blur' }],
      }
    }
  },
  created () {
    this.initDefaultData()
  },
  watch: {
    'form.retireDate' (val) {
      this.retireYear = CalculateAge(val)
    },
    'form.professionalTitle' (val) {
      if (!val) {
        this.form.specificProfessionalTitle = undefined
        this.form.specificProfessionalTitleKey = undefined
        this.form.otherSpecificProfessionalTitle = undefined
      }
    }
  },
  methods: {
    disabledDate (current) {
      return current && current > moment()
    },
    // 初始化默认数据
    async initDefaultData () {
      try {
        let res = await GetPurchaseItemLimitNumAndConsultTelePhone()
        if (res.code === 200 && res.result) {
          let expertItemMaxNum = res.result.expert_item_max_num
          if (expertItemMaxNum) {
            this.expert_item_max_num = parseInt(expertItemMaxNum)
          }
          let phone = res.result.consult_telePhone
          this.consult_telePhone = phone
        }
      } catch (e) {
        this.$message.error(e.message)
      } finally {

      }
    },
    //打开职称窗口
    openProfessional () {
      this.professionalVisible = true
      let result = []
      if (this.form.specificProfessionalTitleKey) {
        let keyArr = this.form.specificProfessionalTitleKey.split('；')
        let nameArr = this.form.specificProfessionalTitle.split('；')
        for (let i = 0; i < keyArr.length; i++) {
          const data = {}
          data['name'] = nameArr[i]
          data['value'] = keyArr[i]
          result.push(data)
        }
      }
      this.$refs.professionalRef.preView(result, this.form.otherSpecificProfessionalTitle)
    },
    //选择职称成功后
    professionalSuccess (data, otherSpecificProfessionalTitle) {
      // todo:读取配置控制多少个
      this.professionalVisible = false
      this.form.specificProfessionalTitle = data.map(item => item.selectedName).join('；')
      this.form.specificProfessionalTitleKey = data.map(item => item.selectedValue).join('；')
      if (otherSpecificProfessionalTitle) {
        this.form.specificProfessionalTitle = this.form.specificProfessionalTitle ? this.form.specificProfessionalTitle + '；' + otherSpecificProfessionalTitle : otherSpecificProfessionalTitle
      }
      this.form.otherSpecificProfessionalTitle = otherSpecificProfessionalTitle
      this.$refs.form.validateField('specificProfessionalTitle')
    },
    //采购品目选择成功后
    purchaseSuccess (data) {
      // todo:读取配置控制多少个
      this.purchaseVisible = false
      this.form.purchaseItem = []
      this.form.purchaseItemId = data.map(item => item.fid).join('；')
      this.form.purchaseItem = data.map(item => item.fspmmc).join('；')
      this.form.purchaseItemCode = data.map(item => item.fspmbm).join('；')
      this.$refs.form.validateField('purchaseItem')
    },
    //打开采购品目
    openPurchaseItems () {
      this.purchaseVisible = true
      let result = []
      if (this.form.purchaseItemId) {
        let fidArr = this.form.purchaseItemId.split('；')
        let itemArr = this.form.purchaseItem.split('；')
        let codeArr = this.form.purchaseItemCode.split('；')
        for (let i = 0; i < fidArr.length; i++) {
          const data = {}
          data['fid'] = fidArr[i]
          data['fspmmc'] = itemArr[i]
          data['fspmbm'] = codeArr[i]
          result.push(data)
        }
      }
      this.$refs.items.preView(result)
    },
    async checkIdCard (rule, value, callback) {
      if (!this.form.certificateType) {
        return callback(new Error('请选择证件类型'))
      }
      if (!value) {
        return callback(new Error('请输入证件号码'))
      }
      if (this.form.certificateType == '1') {
        if (value.length > 18) {
          return callback(new Error('身份证号长度不能超过18位'))
        }
        if (!new RegExp(verify.pattern_idcard15 + '|' + verify.pattern_idcard18).test(value)) {
          return callback(new Error('身份证号格式不正确'))
        }
      }
      const res = await CheckIdCard(value)
      if (res.code !== 200) {
        const consult_telePhone = this.consult_telePhone
        return callback(new Error(res.msg + (res.code == 423 ? `,请拨打${consult_telePhone}电话咨询。` : '')))
      }
    },
    async checkSourceLibrary (rule, value, callback) {
      if (this.form.otherSourceLibraryFlag && !this.form.otherSourceLibrary) {
        return callback(new Error('请选择是否为国家库、省库专家'))
      }
    },
    async otherSourceLibraryValidator (rule, value, callback) {
      if (this.form.otherSourceLibraryFlag && this.otherSourceLibraryFileList.length == 0) {
        return callback(new Error('请上传国家库、省库、省综合库入库证明截图'))
      }
    },
    onCertificateTypeChange (value) {
      this.form.certificateType = value
      this.$refs.form.validateField('idCard')
    },

    //提交信息
    submit () {
      this.$refs.form.validate(async (valid, err) => {
        if (!valid) {
          formWaring(err)
          return
        }
        this.$refs.mobilePhoneCheckModal.init(this.form.mobilePhone)
      })
    },
    async onHandleSubmit (code) {
      try {
        this.form.captcha = code
        const avoidUnit = this.form.avoidUnit
        if (avoidUnit) {
          this.form.avoidUnit = avoidUnit.replace(/[\r\n]+/g, ',').replace(/\s+/g, '')
        }
        const data = { ...this.form }
        data.retireDate = data.retireDate && data.retireDate.format('YYYY-MM-01')

        //移除最后一个匹配到的其他职称
        if (data.otherSpecificProfessionalTitle) {
          if (data.otherSpecificProfessionalTitle === data.specificProfessionalTitle) {
            data.specificProfessionalTitle = undefined
          } else {
            const separator = '；'
            const otherTitle = data.otherSpecificProfessionalTitle
            const regex = new RegExp(`${separator}${otherTitle}$`)
            data.specificProfessionalTitle = data.specificProfessionalTitle.replace(regex, '')
          }
        }
        this.saveLoading = true
        const formData = new FormData()
        for (const key in data) {
          if (data.hasOwnProperty(key) && data[key]) {
            formData.append(key, data[key])
          }
        }
        formData.append('referId', data.id)
        Array.from(this.peoplePictureList).forEach(file => {
          formData.append('peoplePictureList', file)
        })
        Array.from(this.iDCardScannedFileList).forEach(file => {
          formData.append('iDCardScannedList', file)
        })
        Array.from(this.diplomaFileList).forEach(file => {
          formData.append('diplomaFileList', file)
        })
        Array.from(this.technicalTitleCertificatesFileList).forEach(file => {
          formData.append('technicalTitleCertificatesFileList', file)
        })
        Array.from(this.jobQualificationCertificateFileList).forEach(file => {
          formData.append('jobQualificationCertificateFileList', file)
        })
        Array.from(this.otherSourceLibraryFileList).forEach(file => {
          formData.append('otherSourceLibraryFileList', file)
        })
        /* const fileUploadRes = await SaveOutExpertFiles(formData)
        if (fileUploadRes.code !== 200) {
          this.$message.error('上传文件失败，失败原因：' + fileUploadRes.msg)
          this.$refs.mobilePhoneCheckModal.submitLoading = false
          return
        } */
        const res = await SaveOutExpert(formData)
        if (res.code !== 200) {
          this.$error({
            title: `提交失败，失败原因：${res.msg}`,
          })
          this.$refs.mobilePhoneCheckModal.submitLoading = false
          return
        }
        this.$message.success('提交成功')
        this.$refs.mobilePhoneCheckModal.success()
        this.submitSuccess = true
      } catch (e) {
        let ex = e.toString()
        let errorMsg = '专家登记入库失败，请重试'
        if (ex.includes('timeout') || ex.includes('Timeout')) {
          errorMsg = '网络出现延迟卡顿导致入库申请提交超时，请检查您的网络是否顺畅后再重新提交。'
        } else if (ex.includes('Network Error') || ex.includes('network')) {
          errorMsg = '网络连接失败，请检查您的网络连接后重试。'
        } else if (ex.includes('abort')) {
          errorMsg = '请求被中断，请重新提交。'
        }
        this.$error({
          title: '提示',
          content: errorMsg,
        })
      } finally {
        this.$refs.mobilePhoneCheckModal.submitLoading = false
        this.saveLoading = false
      }
    },
    handlePeoplePictureRemove () {
      this.peoplePictureList = []
      this.form.peoplePicture = ''
    },
    async beforePeoplePictureUpload (file) {
      return new Promise(async (resolve, reject) => {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
          this.$message.error('不是有效的 JPG 或 PNG 或 JPEG 文件')
          return reject(false)
        }
        const size = file.size
        if ((size / 1024 / 1024) > 2) {
          this.$message.error('上传文件不能大于2M')
          return reject(false)
        }
        file.url = await getBase64(file)
        this.peoplePictureList = [file]
        return reject(false)
      })
    },
    handlePreview () {

    },
    iDCardScannedUploadFileChange (fileList) {
      this.iDCardScannedFileList = fileList
    },
    diplomaUploadFileChange (fileList) {
      this.diplomaFileList = fileList
    },
    technicalTitleCertificatesUploaFileChange (fileList) {
      this.technicalTitleCertificatesFileList = fileList
    },
    jobQualificationCertificateUploadFileChange (fileList) {
      this.jobQualificationCertificateFileList = fileList
    },
    otherSourceLibraryUploadFileChange (fileList) {
      this.otherSourceLibraryFileList = fileList
    },
    changeOtherSourceLibraryFlag (e) {
      const value = e.target.value
      if (!value) {
        this.form.otherSourceLibrary = ''
        this.otherSourceLibrary = []
      }
    },
    onOtherSourceLibraryChange (val) {
      this.form.otherSourceLibrary = val.join(',')
    }
  }
}
</script>

<style lang="less" scoped>
.main_content {
  /deep/ .ant-divider-horizontal {
    margin: 15px 0;
  }

  .font-red {
    display: inline-block;
    margin-right: 4px;
    color: #f5222d;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
  }

  background: #f9f9f9;

  /deep/ .ant-layout-header {
    height: auto !important;
    background: none;
    padding: 0 !important;
  }

  .header_zj {
    background-image: url('../../../../assets/header_bg.png');
    background-size: 100% 100%;
    background-position: center;
    display: flex;
    align-items: center;
    height: 93px;
    padding: 0 16px;

    .logo {
      flex: 0 0 auto;
    }

    .header_title {
      text-align: center;
      width: 65%;
      margin-left: 20px;
      padding-left: 20px;
      line-height: 30px;
      font-size: 26px;
      color: #fff;
      font-weight: 500;
    }

    .consult_tel {
      font-size: 20px;
      color: #fff;
      font-weight: 500;
    }
  }

  /deep/ .ant-card {
    margin-top: 20px !important;
    width: 70%;
    margin: auto;

    .exi_form {
      margin-bottom: 20px;

      .ant-form-explain {
        z-index: 1;
      }
    }
  }

  .title {
    font-size: 18px;
    font-weight: bold;
    margin-top: 10px;
    border-left: 4px solid #1f76ff;
    line-height: 1;
    padding-left: 8px;
  }

  .descrition-instructions {
    color: #ff4f4f;
    padding: 10px;
    background-color: #fff3e9;
    margin-bottom: 15px;
    font-size: 16px;
  }
}

/deep/ .ant-upload-list-picture-card-container {
  width: 200px;
  height: 200px;

  .ant-upload-list-item {
    width: 150px;
    height: 210px;
    line-height: 150px;
  }
}

.color-red {
  color: red;
}
</style>
